import {Component} from '@angular/core';

@Component({
    selector: 'app-brunata-online-logo-component',
    standalone: true,
    imports: [],
    templateUrl: './brunata-online-logo-component.component.html',
    styleUrl: './brunata-online-logo-component.component.scss',
})
export class BrunataOnlineLogoComponentComponent {}
